import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll restoration beteende baserat på vilken sida vi är på
    if ("scrollRestoration" in window.history) {
      const isAdListingPage =
        pathname === "/lediga-lokaler" ||
        (pathname.startsWith("/lediga-lokaler/") &&
          pathname.split("/").length <= 4);
      if (isAdListingPage) {
        window.history.scrollRestoration = "auto";
        return; // Skippa scroll to top på denna sida
      } else {
        window.history.scrollRestoration = "manual";
      }
    }
    // Scrolla till toppen på alla andra sidor
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, search]);
};

export default useScrollToTop;
